export const tableData = [
    {
      "S.no": 1,
      "user_Persona": "PMS Admin",
      "user_Manual": "PMS Admin User Manual.pdf",
      "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Admin_User_manual.pdf",
      "Role_code":"1"
    },
    {
      "S.no": 2,
      "user_Persona": "Principal Investigator",
      "user_Manual": "Principal Investigator User Manual.pdf",
      "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Principal_Investigator_User_Manual.pdf",
      "Role_code":"2"
    },
    {
        "S.no":3,
        "user_Persona": "Marketing Head",
        "user_Manual": "Marketing Head User Manual.pdf",
        "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Marketing_Head_User_Manual.pdf",
        "Role_code":"3"

    },
    {
        "S.no":4,
        "user_Persona": "Quality Reviewer",
        "user_Manual": "Quality Reviewer User Manual.pdf",
        "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Quality_Reviewer_User_Manual.pdf",
        "Role_code":"4"
      
      },
      {
        "S.no":5,
        "user_Persona": "Medical Reviewer",
        "user_Manual": "Medical Reviewer User Manual.pdf",
        "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Medical_Reviewer_User_Manual.pdf",
        "Role_code":"5"
    
    },
    {
      "S.no":6,
      "user_Persona": "Marketing Staff",
      "user_Manual": "Marketing Staff User Manual.pdf",
      "user_Url": "https://d2g59ienhd3jw4.cloudfront.net/user_manuals/Marketing_Staff_User_Manual.pdf",
      "Role_code":"6"

  },
 


    // Add more data as needed
  ];